import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { RoleDisplayPipe } from "./role-display.pipe";
import { LocationDisplayPipe } from "./location-display.pipe";
import { LocationDisplayWithPlaceholderPipe } from "./location-display-with-placeholder.pipe";
import { OrderSkillsByProficiencyThenNamePipe } from "./order-skills-by-proficiency-then-name.pipe";
import { SanitizeHtmlPipe } from "./sanitize-html.pipe";
import { SkillAndRatingDisplayPipe } from "./skill-and-rating-display";
import { SkillRatingDisplayPipe } from "./skill-rating-display.pipe";
import { NameDisplayPipe } from "./name-display.pipe";
import { OrgDisplayPipe } from "./org-display.pipe";

@NgModule({
  declarations: [
    RoleDisplayPipe,
    LocationDisplayPipe,
    LocationDisplayWithPlaceholderPipe,
    OrderSkillsByProficiencyThenNamePipe,
    SanitizeHtmlPipe,
    SkillAndRatingDisplayPipe,
    SkillRatingDisplayPipe,
    NameDisplayPipe,
    OrgDisplayPipe,
  ],
  imports: [CommonModule],
  exports: [
    RoleDisplayPipe,
    LocationDisplayPipe,
    LocationDisplayWithPlaceholderPipe,
    OrderSkillsByProficiencyThenNamePipe,
    SanitizeHtmlPipe,
    SkillAndRatingDisplayPipe,
    SkillRatingDisplayPipe,
    NameDisplayPipe,
    OrgDisplayPipe,
  ],
})
export class PipesModule {}
